import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { HTTP_CONFIG_OPTIONS, HttpConfigOptions } from './config/HttpConfig';
import { ErrorResponseInterceptor } from './interceptors/ErrorResponseInterceptor';
import { RequestInterceptor } from './interceptors/RequestInterceptor';



@NgModule({
  imports: [
    HttpClientModule
  ]
})
export class HttpModule {
  static forRoot(options: Partial<HttpConfigOptions>): ModuleWithProviders<HttpModule> {
    return {
      ngModule: HttpModule,
      providers: [
        {
          provide: HTTP_CONFIG_OPTIONS,
          useValue: options
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RequestInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorResponseInterceptor,
          multi: true
        }
      ]
    };
  }
}
